import { ForbiddenState, ListEmptyState } from "@/ds";
import { ObrasKanbanBoard } from "@/shared/components";
import { FINANCEIRO_FORBIDDEN_CARDS_DESCRIPTION } from "../../financeiro-obras.constants";
import type {
  FinanceiroObrasCardsViewModel,
  FinanceiroObrasCardsViewProps,
} from "./types-financeiro-obras-cards-view";

type ViewProps = Pick<FinanceiroObrasCardsViewProps, "onClearSearch" | "onClearFilters"> &
  FinanceiroObrasCardsViewModel;

/**
 * Visão Cards: uma coluna por status financeiro, sem arrastar entre colunas; até 10 obras por coluna e "Mostrar mais
 * obras" (+10, pelo servidor) enquanto houver mais. O quadro é o `ObrasKanbanBoard` do shared, o mesmo de Obras.
 */
export function FinanceiroObrasCardsView({
  device,
  boardColumns,
  forbidden,
  isEmpty,
  hasSearch,
  hasFilters,
  onClearSearch,
  onClearFilters,
}: ViewProps) {
  if (forbidden) {
    return (
      <ForbiddenState
        description={FINANCEIRO_FORBIDDEN_CARDS_DESCRIPTION}
        testId="financeiro-obras-forbidden"
      />
    );
  }

  if (isEmpty) {
    return (
      <ListEmptyState
        noun="obra"
        gender="f"
        hasSearch={hasSearch}
        hasFilters={hasFilters}
        onClear={hasSearch ? onClearSearch : hasFilters ? onClearFilters : undefined}
        testId="financeiro-obras-empty"
      />
    );
  }

  return (
    <ObrasKanbanBoard testId="financeiro-obras-cards" device={device} columns={boardColumns} />
  );
}
